import React from 'react';
import { Star } from 'lucide-react';
import { Badge } from '../ui/badge';
import { GALLERY_IMAGES } from '../../config/constants';

const About = () => {
  return (
    <section id="about" className="py-20 px-4 bg-zinc-900" data-testid="about-section">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <Badge className="bg-amber-500 text-black mb-4 px-4 py-1 text-sm">CHI SIAMO</Badge>
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6">
              Roger'S Club<br />
              <span className="text-amber-500">Barberia</span>
            </h2>
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                La cura del proprio aspetto è fondamentale non solo per l'immagine esteriore, ma anche per il benessere psicologico e sociale.
              </p>
              <p>
                Prendersi cura di sé stessi, attraverso una corretta igiene e attenzione allo stile, migliora l'autostima e favorisce una percezione positiva di sé.
              </p>
              <p>
                Inoltre, avere un aspetto curato può influenzare positivamente le interazioni sociali e professionali, creando un'impressione di <strong className="text-white">affidabilità</strong> e <strong className="text-white">serietà</strong>.
              </p>
              <p className="text-amber-500 font-semibold italic">
                "La cura personale è un investimento sul proprio equilibrio emotivo e sulla propria felicità."
              </p>
            </div>
          </div>
          <div className="relative">
            <img 
              src={GALLERY_IMAGES[1]} 
              alt="Roger'S Club Barberia" 
              className="rounded-sm shadow-2xl w-full"
            />
            <div className="absolute -bottom-6 -left-6 bg-amber-500 text-black p-6 max-w-xs">
              <div className="text-4xl font-bold">5.0</div>
              <div className="flex gap-1 my-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} fill="currentColor" />
                ))}
              </div>
              <div className="text-sm font-semibold">60 recensioni Google</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
